import { useState } from 'react'
import { useFlexSearch } from 'react-use-flexsearch'

export default function useSearch(index, store) {
  const [query, setQuery] = useState()

  const results = useFlexSearch(query, JSON.stringify(index), store)

  function search(inputQuery) {
    setQuery(inputQuery)
  }

  return [results, search]
}
